import { UAPPlacementTypeAlias as EPT } from '@bingads-webui-campaign-react/unified-ad-preview-library-cmui';

const imageExtConfigAll = {
  placementConfig: [{
    placementSetName: 'imageExtensionConfigAll',
    placementTypes: [
      EPT.ImageExt.BingDesktopSingleImage,
      EPT.ImageExt.BingDesktopMultiImage, // multi-image placement
      EPT.ImageExt.BingMobileMultiImage, // multi-image placement
      EPT.ImageExt.WideImage,
      EPT.ImageExt.MSEdgeSingleCarousel,
      EPT.ImageExt.MSEdgeMediumHeadline,
      EPT.ImageExt.MSNSingleCarousel,
      EPT.ImageExt.MSNMediumHeadline,
      EPT.ImageExt.MSNInArticle,
      EPT.ImageExt.MSNSmallHeadline,
      EPT.ImageExt.SquareImage,
      EPT.ImageExt.MSNDoubleCarousel,
    ],
  }],
};

const imageExtConfigAllV2 = {
  placementConfig: [{
    placementSetName: 'imageExtensionConfigAll',
    placementTypes: [
      EPT.ImageExt.BingDesktopSingleImage,
      EPT.ImageExt.BingDesktopMultiImage, // multi-image placement
      EPT.ImageExt.BingMobileMultiImage, // multi-image placement
      EPT.ImageExt.MSEdgeMediumHeadline,
      EPT.ImageExt.MSEdgeMobile,
      EPT.ImageExt.MMAV2MSNRiver,
      EPT.ImageExt.MMAV2MSNSingleCarousel,
      EPT.ImageExt.MSEdgeSingleCarousel,
      EPT.ImageExt.MSNMediumHeadline,
      EPT.ImageExt.MSNInArticle,
      EPT.ImageExt.MSNSmallHeadline,
      EPT.ImageExt.MSNDoubleCarousel,
    ],
  }],
};

const imageExtConfigSingleImage = {
  placementConfig: [{
    placementSetName: 'imageExtensionConfigSingle',
    placementTypes: [
      EPT.ImageExt.BingDesktopSingleImage,
      EPT.ImageExt.WideImage,
      EPT.ImageExt.MSEdgeSingleCarousel,
      EPT.ImageExt.MSEdgeMediumHeadline,
      EPT.ImageExt.MSNSingleCarousel,
      EPT.ImageExt.MSNMediumHeadline,
      EPT.ImageExt.MSNInArticle,
      EPT.ImageExt.MSNSmallHeadline,
      EPT.ImageExt.SquareImage,
      EPT.ImageExt.MSNDoubleCarousel,
    ],
  }],
};

const imageExtConfigSingleImageV2 = {
  placementConfig: [{
    placementSetName: 'imageExtensionConfigSingle',
    placementTypes: [
      EPT.ImageExt.BingDesktopSingleImage,
      EPT.ImageExt.MSEdgeMediumHeadline,
      EPT.ImageExt.MSEdgeMobile,
      EPT.ImageExt.MMAV2MSNRiver,
      EPT.ImageExt.MMAV2MSNSingleCarousel,
      EPT.ImageExt.MSEdgeSingleCarousel,
      EPT.ImageExt.MSNMediumHeadline,
      EPT.ImageExt.MSNInArticle,
      EPT.ImageExt.MSNSmallHeadline,
      EPT.ImageExt.MSNDoubleCarousel,
    ],
  }],
};

const imageExtConfigAllMultiImage = {
  placementConfig: [{
    placementSetName: 'imageExtensionConfigMulti',
    placementTypes: [
      EPT.ImageExt.BingDesktopMultiImage,
      EPT.ImageExt.BingMobileMultiImage,
    ],
  }],
};

export const getUnifiedAdPreviewConfig = ({ eligibleLayout, isAdPreviewRefreshEnabled }) => {
  if (eligibleLayout === 'Multi') {
    return imageExtConfigAllMultiImage;
  }
  if (eligibleLayout === 'Single') {
    return isAdPreviewRefreshEnabled ? imageExtConfigSingleImageV2 : imageExtConfigSingleImage;
  }
  return isAdPreviewRefreshEnabled ? imageExtConfigAllV2 : imageExtConfigAll;
};
